export default __webpack_public_path__ + "static/media/O-010.8ccb2526.png";